import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../../utl/models/Error";
import { UserState } from "../../models/UserState";

const registerVendorFailure = (state: UserState, action: PayloadAction<Error>) => {
    state.isLoading = false;
    state.isError = action.payload.error;
}

export default registerVendorFailure;